export const lineMixins = {
  methods: {
    // TODO: Deprecated
    getFieldWidth (fieldName) {
      switch (fieldName) {
        case 'description':
          return this.entityType !== 'ar' ? '20%' : '15%'
        case 'line_number':
        case 'asset':
          return '2.5%'
      }
      return this.entityType !== 'ar' ? '7.27%' : (this.$route.params.id ? '5.8%' : '6.27%')
    }
  }
}



// WEBPACK FOOTER //
// ./src/Mixins/Lines.js